import { render, staticRenderFns } from "./cebao.vue?vue&type=template&id=a13c08f6&scoped=true&"
import script from "./cebao.vue?vue&type=script&lang=js&"
export * from "./cebao.vue?vue&type=script&lang=js&"
import style0 from "./cebao.vue?vue&type=style&index=0&id=a13c08f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a13c08f6",
  null
  
)

export default component.exports